import DOMPurify from 'dompurify';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/shared/IconCollecion';
import type { ToastType, ToastView } from '../types';
import { COLOR } from './style';

// Иконки типов — Lucide, как в макете (stroke 2.25 на 18px).
const svg = (children: ReactElement) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="size-[18px]"
    aria-hidden
  >
    {children}
  </svg>
);

const ICONS: Record<ToastType, ReactElement> = {
  success: svg(<path d="M20 6 9 17l-5-5" />),
  error: svg(
    <>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </>,
  ),
  warning: svg(
    <>
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
      <path d="M12 9v4" />
      <path d="M12 17h.01" />
    </>,
  ),
  info: svg(
    <>
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </>,
  ),
};

// Имя в кавычках — в отдельный span цвета бренда. Сообщение затем всё равно
// проходит DOMPurify: имя потока вводит партнёр.
const highlightNames = (message: string) =>
  message.replace(/([«“"])([^«»“”"]+)([»”"])/g, '<span class="text-content-accent">$1$2$3</span>');

export const CloseButton = ({ closeToast }: { closeToast?: () => void }) => {
  const { t } = useTranslation('common');

  return (
    <button
      type="button"
      onClick={closeToast}
      title={t('close')}
      aria-label={t('close')}
      className="flex size-7 shrink-0 items-center justify-center rounded-full text-content-secondary transition-colors hover:bg-surface-muted"
    >
      <Icon name="Close" color="currentColor" className="size-4" />
    </button>
  );
};

export const ToastItem: ToastView['ToastItem'] = ({ type, message }) => (
  <div className="flex min-w-0 flex-1 items-center gap-3">
    <span
      className="flex size-[34px] shrink-0 items-center justify-center rounded-full"
      style={{ background: COLOR[type].tint, color: COLOR[type].color }}
    >
      {ICONS[type]}
    </span>
    <span
      className="min-w-0 flex-1 text-sm font-bold leading-[1.4] text-content-primary"
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highlightNames(message)) }}
    />
  </div>
);
